<template>
  <div class="nickN">
    <p>（一）违反国家相关法律法规，公序良俗，和社会一般道德规范的。</p>
    <p>（二）使用含有国家领导人名字的昵称；使用与近期名人或行业热门大V相同的昵称，比如胡锡进、猫笔刀、但斌等；</p>
    <p>（三）使用与平台已认证高手账号、投顾账号高度相似的昵称，容易造成用户混淆的。</p>
    <p>（四）使用“XX老师战队”“某家军”“某某府”等高度统一的马甲昵称，（含昵称前后添加该类马甲）的；</p>
    <p>（五）公开或私下引导、鼓动粉丝修改包含其特定标识（如用户名、昵称、专属词汇等）的昵称，比如上述某家军**，某某战队**，某某老师粉丝，某王府**等，以形成具有排他性或组织性的网络小团体；</p>
    <p>（六）使用不文明、侮辱性、歧视性、攻击性的词汇；</p>
    <p>（七）使用上市公司简称、ETF、题材板块的名字；</p>
    <p>（八）扰乱平台秩序及误导用户的内容：含有“爱股票”“平台官方”“管理员”“客服”等易被误认为平台官方账号的字样或标识的；</p>
    <p>（九）带有营销、广告性质的内容：包含电话号码、二维码、第三方平台链接、QQ群/微信群号等站外联系方式的；推广电商商品、知识付费课程、其他金融平台等营销信息的；</p>
    <p>（十）其他违规内容：使用变体字、繁体字、谐音字、拼音缩写、标点符号、特殊符号组合等方式规避平台审核的；与平台社区定位不符，且可能引发不良影响的其他内容；</p>
    <p>以上十条内容所描述的情形，平台将严格禁止。相关昵称的新建和修改，平台将不予审核通过。敬请理解。</p>
    <p>本规定自2025年12月30日起正式执行。</p>

  </div>
</template>

<script>
export default {
    data(){
        return{
        }
    },
    created(){

    },
    methods:{

    },
    computed:{

    },
}
</script>

<style scoped lang="scss">
.nickN{

    padding: 0 10px;

    background: #fff;
    >p{
        margin: 10px 0;
        font-size: 14px;
        line-height: 1.5;
    }
}
</style>